import CssBaseline from "@mui/material/CssBaseline";
import SideMenu from "../components/SideMenu";
import {alpha} from "@mui/material/styles";
import Header from "../components/Header";
import AppTheme from "../mui-theme/AppTheme";
import Card from '@mui/material/Card';
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import * as React from "react";

import {
    chartsCustomizations,
    dataGridCustomizations,
    datePickersCustomizations,
    treeViewCustomizations,
} from '../theme/customizations';
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";
import Button from "@mui/material/Button";
import MouseTracker from "../components/MouseTracker";

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
};

export default function TransactionCheck(props) {
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['session-token']);
    const [transactionData, setTransactionData] = React.useState({});

    useEffect(() => {
        const token = cookies['session-token'];
        fetch('/api/check_transaction', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: token,
            })
        }).then(res => {
            if (!res.ok) {
                if (res.status === 401) {
                    removeCookie('session-token', {path: '/'});
                    navigate('/sign-in');
                } else if (res.status === 404) {
                    // Handle case where transaction data expired
                    alert("Ihr Log-in für diese Transaktion ist ausgelaufen. Bitte starten Sie den Überweisungsvorgang von vorne.");
                    navigate('/transaction');
                }
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        }).then(data => {
            setTransactionData(data);
        }).catch(err => {
            console.error("Failed to fetch transaction data:", err);
        });
    }, [cookies, navigate, removeCookie]);

    const handleConfirm = () => {
        fetch('/api/confirm_transaction', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
            })
        }).then(res => res.json())
            .then(data => {
                if (data.status === 'transaction_successful') {
                    // Optionally show a success message before navigating
                    alert('Die Überweisung wurde erfolgreich registriert.');
                    navigate('/');
                } else {
                    alert('Beim abschicken der Überweisung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
                }
            }).catch(err => {
            console.error("Failed to confirm transaction:", err);
            alert('An unexpected error occurred.');
        });
    };

    // Helper to format the amount safely
    const formatAmount = (amountInCents) => {
        if (amountInCents === undefined || amountInCents === null) {
            return '0,00';
        }
        const numericAmount = parseInt(amountInCents, 10);
        if (isNaN(numericAmount)) {
            return '0,00';
        }
        const valueInEuros = numericAmount / 100;
        return valueInEuros.toFixed(2).replace(".", ",").replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    };

    return (
        <AppTheme themeComponents={xThemeComponents}>
            <MouseTracker/>
            <CssBaseline enableColorScheme/>
            <Box sx={{display: 'flex'}}>
                <SideMenu selected={-1}/>
                {/* Main content */}
                <Box
                    component="main"
                    sx={(theme) => ({
                        flexGrow: 1,
                        backgroundColor: theme.vars
                            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                            : alpha(theme.palette.background.default, 1),
                        overflow: 'auto',
                    })}
                >
                    <Stack
                        spacing={2}
                        sx={{
                            alignItems: 'center',
                            mx: 3,
                            pb: 5,
                            mt: {xs: 8, md: 0},
                        }}
                    >
                        <Box sx={{width: '100%', maxWidth: {sm: '100%', md: '1700px'}}}>
                            <Card variant="outlined"
                                  style={{maxWidth: '50em', width: '100%', marginRight: 'auto', padding: '2em'}}>
                                <Typography component="h2" variant="h2" sx={{mb: 2}}>
                                    Überweisung überprüfen
                                </Typography>

                                {Object.keys(transactionData).length > 0 ? (
                                    <div style={{maxWidth: '50em', width: '100%'}}>
                                        <Typography>Sie überweisen vom
                                            Konto <strong>{transactionData['sourceIBAN']}</strong> an</Typography>
                                        <Typography
                                            sx={{
                                                margin: '1em 0',
                                                fontSize: '200%'
                                            }}>{transactionData['name']}</Typography>
                                        <Typography>IBAN: <strong>{transactionData['sendIBAN']}</strong></Typography>
                                        <Typography>BIC: <strong>{transactionData['bic']}</strong></Typography>
                                        <Typography sx={{margin: '1em 0'}}>Einen Betrag von
                                            <span style={{fontSize: '200%', fontWeight: 'bold', padding: '0 0.5em'}}>
                                                {formatAmount(transactionData['amount'])} €
                                            </span>
                                        </Typography>
                                        <Typography>Verwendungszweck: <strong>{transactionData['purpose']}</strong></Typography>
                                        <Typography
                                            sx={{margin: '1em 0'}}>Kundenreferenz: {transactionData['reference']}</Typography>
                                        <Stack spacing={2} direction="row">
                                            <Button variant="outlined"
                                                    onClick={() => navigate('/transaction')}>Zurück</Button>
                                            <Button variant="contained" onClick={handleConfirm}>Überweisung
                                                abschicken</Button>
                                        </Stack>
                                    </div>
                                ) : (
                                    <Typography>Transaktionsdaten werden geladen...</Typography>
                                )}
                            </Card>
                        </Box>
                    </Stack>
                </Box>
            </Box>
        </AppTheme>
    );
}